export default __webpack_public_path__ + "static/media/flag.74963cac.svg";